import { Helmet } from "react-helmet";
import { Outlet, Route, Routes } from "react-router-dom";
import Layout from "../layout/Layout";
import Account from "./Account";
import Host from "./Host";
import HostDump from "./HostDump";
import Search from "./Search";

export default function Register() {
    return (
        <>
            <Helmet>
                <title>Get Started with Podtrac</title>
            </Helmet>
            <Routes>
                <Route path="*" element={<Layout />}>
                    <Route
                        path="*"
                        element={
                            <div style={{ maxWidth: "90ch", margin: "auto" }}>
                                <Outlet />
                            </div>
                        }
                    >
                        <Route index element={<Search />} />
                        <Route path="host" element={<Host />} />
                        <Route path="account" element={<Account />} />
                        <Route path="__hosts/*" element={<HostDump />} />
                    </Route>
                </Route>
            </Routes>
        </>
    );
}
